import React, { Component, Fragment } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { initialData } from "../config";
import Api from "../../../../Services/Api";
import { mapToObjectDDL } from "../../../common/mapper";
import { fetchDataAsync } from "../../../../Services/Utils";

class ManagementApprovalFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      periodeOption: [
        { value: "TANGGAL_REQUEST", label: "TANGGAL REQUEST" },
        { value: "TANGGAL_KEPUTUSAN", label: "TANGGAL KEPUTUSAN" },
      ],
      menuOption: [],
      deskripOption: [],
      statusOption: [
        { value: "INCOMPLETE", label: "INCOMPLETE" },
        { value: "REJECT", label: "REJECT" },
        { value: "APPROVED", label: "APPROVED" },
      ],
      periode: { value: "TANGGAL_REQUEST", label: "TANGGAL REQUEST" },
    };
  }

  componentDidMount = () => {
    this.fetchDataApproval();
    this.fetchDataMenu();
  };

  fetchDataApproval = async () => {
    try {
      let req = {paramFilters: {}, page: null, limit: null};
      let response = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterApprovalFindByParam,
          menuName: "Master Approval",
          setError: this.props.setError,
          args: req,
      });
      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          deskripOption: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataMenu = async () => {
    try {
      let response = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_AUTH").getAllMenuForApproval,
          menuName: "Master Approval",
          setError: this.props.setError,
      });
      
      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          menuOption: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  render() {
    const { filterData } = this.props;
    const { periode } = filterData;

    const isRequest = periode?.value === "TANGGAL_REQUEST";
    const startName = isRequest ? "startRequestDate" : "startApprovalDate";
    const endName = isRequest ? "endRequestDate" : "endApprovalDate";

    const startDate = filterData[startName];
    const endDate = filterData[endName];
    const hasStart = !!startDate;

    return (
      <Fragment>
        <SimpleModal
          title="Filter"
          visible={this.props.visible}
          onClickClose={this.props.onClickClose}
          styles={{ width: "40%" }}
          content={
            <ModalContainer>
              <SimpleInput
                id="input_text_id_pelanggaran"
                name="idPelanggaran"
                label="ID Pelanggaran"
                value={filterData.idPelanggaran}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />

              <SimpleDDL
                id="select_options_menu"
                name="module"
                box="search"
                label="Modul/Menu"
                options={this.state.menuOption.map((item) =>
                  mapToObjectDDL(item.moduleName, item.moduleCode)
                )}
                value={filterData.module}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />

              <SimpleDDL
                id="select_options_desc"
                name="deskripsiPelanggaran"
                box="search"
                label="Deskripsi Pelanggaran"
                options={this.state.deskripOption.map((item) =>
                  mapToObjectDDL(item.approvalDescription, item.approvalDescription)
                )}
                value={filterData.deskripsiPelanggaran}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />

              <SimpleInput
                id="input_text_no_document"
                name="nomorDokumenReferensi"
                label="Nomor Dokumen"
                value={filterData.nomorDokumenReferensi}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />

              <SimpleInput
                id="input_text_user"
                name="userPemohon"
                label="User Pemohon"
                value={filterData.userPemohon}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />

              <SimpleInput
                id="input_text_auth_by"
                name="authorizedBy"
                label="Authorized By"
                value={filterData.authorizedBy}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value)
                }
              />

              <SimpleDDL
                id="select_options_status"
                name="status"
                label="Status"
                box="search"
                options={this.state.statusOption}
                value={filterData.status}
                onChange={(value, { name }) =>
                  this.props.onValueChange(name, value)
                }
              />

              <div
                className="txt-site txt-11 txt-main txt-bold"
                style={{ marginTop: 15 }}
              >
                <h4>Periode</h4>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "20px" }}
              >
                <SimpleDDL
                  id="select_options_periode"
                  name="periode"
                  box="search"
                  options={this.state.periodeOption}
                  value={filterData.periode}
                  onChange={(value) =>
                    this.props.onValueChange("periode", value)
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      width: 240,
                    }),
                  }}
                />

                <SimpleDate
                  id="select_date_start_date"
                  name={startName}
                  nextdate
                  date={startDate}
                  maxDate={endDate}
                  onChange={(value) =>
                    this.props.onValueChange(startName, value)
                  }
                  style={{ width: 150 }}
                />

                <span style={{ marginBottom: 5 }}>s/d</span>

                <SimpleDate
                  id="select_date_end_date"
                  name={endName}
                  backdate
                  disabled={!hasStart}
                  minDate={startDate || null}
                  date={endDate}
                  onChange={(value) => this.props.onValueChange(endName, value)}
                  style={{ width: 150 }}
                />
              </div>

              {/* Buttons */}
              <div style={{ textAlign: "right", marginTop: 20 }}>
                <SimpleButton
                  type="button"
                  text="Hapus"
                  onClick={this.props.onClearFilter}
                />
                <SimpleButton
                  type="button"
                  text="Terapkan"
                  onClick={this.props.onSubmit}
                />
              </div>
            </ModalContainer>
          }
        />

        <SimpleLoadingOverlay active={this.state.loading} />
      </Fragment>
    );
  }
}

export default ManagementApprovalFilter;
